import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25bf86e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "main-div" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pClass" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Could you issue following contents?")
], -1 /* HOISTED */))
const _hoisted_5 = {
  id: "tbldiv",
  class: "tbl-div"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tblTitle-div",
  style: {"width":"calc(100% - 16px)"}
}, [
  /*#__PURE__*/_createElementVNode("table", {
    id: "tblIssueSalesNote",
    class: "w-100"
  }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"50%"} }, "Sales No."),
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"50%"} }, "Production Month")
    ])
  ])
], -1 /* HOISTED */))
const _hoisted_7 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_8 = {
  id: "tblIssueSalesNoteDetail",
  class: "w-100"
}
const _hoisted_9 = { id: "tbltbody" }
const _hoisted_10 = { style: {"width":"50%"} }
const _hoisted_11 = { style: {"width":"50%"} }
const _hoisted_12 = { class: "btn-div" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    ($setup.isLoadingcheck == 'true')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paramSalesNote, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(info.salesNo), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(info.prodYM.slice(0, 4) + '/' + info.prodYM.slice(4, 6)), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-cancel",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showModal()))
        }, "All Cancel"),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-circulation",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.setConfirmationRoute()))
        }, "Set Confirmation Route")
      ])
    ])
  ]))
}